module.exports = __webpack_public_path__ + "static/media/homepage-mobile.54a15c71.svg";